import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { t } from '@slot-nx/core'

export const Paragraph3 = (props: ParagraphProps) => {
  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Text
          text={t('gameRules_title2')}
          anchor={[0.5, 1]}
          x={props.width / 2}
          style={tableTitleStyle}
        />
        <Text
          x={60}
          y={50}
          text={(t('gameRules_title2_content_1'))}
          style={paragraphStyle}
        />
        <Text
          x={60}
          y={200}
          text={(t('gameRules_title2_content_2'))}
          style={paragraphStyle}
        />
      </Container>

    )
  }
  , [])
  return content
}
